import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
import { customScroll, transitionGrow } from '../theme/mixins';
import Popper from '../Popper';
import Paper from '../Paper';
export var PopperStyled = styled(Popper).withConfig({
  displayName: "ui-kit-PopperStyled",
  componentId: "ui-kit-3ohy68"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  pointer-events: none;\n\n  &.withBackdrop {\n    pointer-events: auto;\n  }\n"], ["\n  pointer-events: none;\n\n  &.withBackdrop {\n    pointer-events: auto;\n  }\n"])));
export var Root = styled.div.withConfig({
  displayName: "ui-kit-Root",
  componentId: "ui-kit-8ff25h"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
export var PaperStyled = styled(Paper).withConfig({
  displayName: "ui-kit-PaperStyled",
  componentId: "ui-kit-13qmkjs"
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  pointer-events: auto;\n  overflow-y: auto;\n  overflow-x: hidden;\n  min-width: 16px;\n  min-height: 16px;\n  max-width: calc(100vw - 32px);\n  max-height: calc(100vh - 32px);\n  outline: none;\n  -webkit-overflow-scrolling: touch;\n  background-color: ", ";\n  ", "\n\n  ", "[data-popper-placement='left'] & {\n    transform-origin: right center;\n  }\n  ", "[data-popper-placement='left-start'] & {\n    transform-origin: right top;\n  }\n  ", "[data-popper-placement='left-end'] & {\n    transform-origin: right bottom;\n  }\n\n  ", "[data-popper-placement='right'] & {\n    transform-origin: left center;\n  }\n  ", "[data-popper-placement='right-start'] & {\n    transform-origin: left top;\n  }\n  ", "[data-popper-placement='right-end'] & {\n    transform-origin: left bottom;\n  }\n\n  ", "[data-popper-placement='top'] & {\n    transform-origin: center bottom;\n  }\n  ", "[data-popper-placement='top-start'] & {\n    transform-origin: left bottom;\n  }\n  ", "[data-popper-placement='top-end'] & {\n    transform-origin: right bottom;\n  }\n\n  ", "[data-popper-placement='bottom'] & {\n    transform-origin: center top;\n  }\n  ", "[data-popper-placement='bottom-start'] & {\n    transform-origin: left top;\n  }\n  ", "[data-popper-placement='bottom-end'] & {\n    transform-origin: right top;\n  }\n\n  ", "[data-popper-placement^='left'] &,\n  ", "[data-popper-placement^='right'] & {\n    margin: 0 8px;\n  }\n  ", "[data-popper-placement^='top'] &,\n  ", "[data-popper-placement^='bottom'] & {\n    margin: 8px 0;\n  }\n\n  ", "\n"], ["\n  pointer-events: auto;\n  overflow-y: auto;\n  overflow-x: hidden;\n  min-width: 16px;\n  min-height: 16px;\n  max-width: calc(100vw - 32px);\n  max-height: calc(100vh - 32px);\n  outline: none;\n  -webkit-overflow-scrolling: touch;\n  background-color: ", ";\n  ", "\n\n  "
/* sc-sel */
, "[data-popper-placement='left'] & {\n    transform-origin: right center;\n  }\n  "
/* sc-sel */
, "[data-popper-placement='left-start'] & {\n    transform-origin: right top;\n  }\n  "
/* sc-sel */
, "[data-popper-placement='left-end'] & {\n    transform-origin: right bottom;\n  }\n\n  "
/* sc-sel */
, "[data-popper-placement='right'] & {\n    transform-origin: left center;\n  }\n  "
/* sc-sel */
, "[data-popper-placement='right-start'] & {\n    transform-origin: left top;\n  }\n  "
/* sc-sel */
, "[data-popper-placement='right-end'] & {\n    transform-origin: left bottom;\n  }\n\n  "
/* sc-sel */
, "[data-popper-placement='top'] & {\n    transform-origin: center bottom;\n  }\n  "
/* sc-sel */
, "[data-popper-placement='top-start'] & {\n    transform-origin: left bottom;\n  }\n  "
/* sc-sel */
, "[data-popper-placement='top-end'] & {\n    transform-origin: right bottom;\n  }\n\n  "
/* sc-sel */
, "[data-popper-placement='bottom'] & {\n    transform-origin: center top;\n  }\n  "
/* sc-sel */
, "[data-popper-placement='bottom-start'] & {\n    transform-origin: left top;\n  }\n  "
/* sc-sel */
, "[data-popper-placement='bottom-end'] & {\n    transform-origin: right top;\n  }\n\n  "
/* sc-sel */
, "[data-popper-placement^='left'] &,\n  "
/* sc-sel */
, "[data-popper-placement^='right'] & {\n    margin: 0 8px;\n  }\n  "
/* sc-sel */
, "[data-popper-placement^='top'] &,\n  "
/* sc-sel */
, "[data-popper-placement^='bottom'] & {\n    margin: 8px 0;\n  }\n\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return theme.palette.background.neutral.popover;
}, function (_a) {
  var theme = _a.theme;
  return customScroll({
    backgroundColor: theme.palette.background.neutral.popover
  });
},
/* sc-sel */
Root,
/* sc-sel */
Root,
/* sc-sel */
Root,
/* sc-sel */
Root,
/* sc-sel */
Root,
/* sc-sel */
Root,
/* sc-sel */
Root,
/* sc-sel */
Root,
/* sc-sel */
Root,
/* sc-sel */
Root,
/* sc-sel */
Root,
/* sc-sel */
Root,
/* sc-sel */
Root,
/* sc-sel */
Root,
/* sc-sel */
Root,
/* sc-sel */
Root, transitionGrow({
  startSelector: '.grow-appear > &, .grow-enter > &',
  startActiveSelector: '.grow-appear-active > &, .grow-enter-active > &',
  exitSelector: '.grow-exit > &',
  exitActiveSelector: '.grow-exit-active > &'
}));
var templateObject_1, templateObject_2, templateObject_3;